// extracted by mini-css-extract-plugin
export default {"root":"gift_campaign_options_list_root__EApX5","optionContainer":"gift_campaign_options_list_optionContainer__m8+YC"};